import { useState } from 'react';
import * as Yup from 'yup';
import { validarCpf } from '../../../shared/utils/Validacao';

const useForm = (clienteDGKPSC) => {

    const validationSchema = Yup.object().shape({
        numeroEtiqueta: Yup.string().required('Campo obrigatório').max(13, 'O número de etiquetas deve ter no máximo 13 caracteres'),
        empresa: Yup.string().required('Campo obrigatório'),
        tipoAmostra: Yup.string().required('Campo obrigatório'),
        tipoConservacao: Yup.string().required('Campo obrigatório'),
        nomePaciente: Yup.string().required('Campo obrigatório'),
        cpf: clienteDGKPSC ? 
        Yup.mixed().nullable().required('Campo obrigatório').test('cpf', 'CPF inválido', (value) => validarCpf(value)) : 
        Yup.string().test('cpf', 'CPF inválido', (value) => validarCpf(value)),
        convenio: clienteDGKPSC ? Yup.string().required('Campo obrigatório') : "",
        numeroCarteira: clienteDGKPSC ? Yup.string().required('Campo obrigatório') : "",
        dataNascimento: clienteDGKPSC ? Yup.string().required('Campo obrigatório') : "",
        dataColeta: clienteDGKPSC ? Yup.string().required('Campo obrigatório') : "",
        horaColeta: clienteDGKPSC ? Yup.string().required('Campo obrigatório') : "",
        sexo: clienteDGKPSC ? Yup.string().required('Campo obrigatório') : "",
        exames: clienteDGKPSC ? Yup.array().of(Yup.string().min(1)).required('Campo obrigatório'): ""
    });

    const initialValues = {
        numeroEtiqueta: '',
        empresa: '',
        tipoAmostra: '',
        tipoConservacao: '',
        especificacao: '',
        nomePaciente: '',
        cpf: '',
        dataPedido: '',
        numeroPedido: '',
        convenio: '',
        numeroCarteira: '',
        dataNascimento: '',
        dadosSolicitante:'',
        dataColeta:'',
        horaColeta:'',
        sexo:'',
        exames:null,
        material:null,
        especificacao:null
    };

    const initialErrors = {
        numeroEtiqueta: 'Campo obrigatório',
        empresa: 'Campo obrigatório',
        tipoAmostra: 'Campo obrigatório',
        tipoConservacao: 'Campo obrigatório',
        especificacao: '',
        nomePaciente: 'Campo obrigatório',
        dataPedido: '',
        numeroPedido: '',
        convenio: 'Campo obrigatório',
        numeroCarteira: 'Campo obrigatório',
        dataNascimento: clienteDGKPSC ? 'Campo obrigatório' : '',
        dadosSolicitante: clienteDGKPSC ? 'Campo obrigatório' : '',
        dataColeta: clienteDGKPSC ? 'Campo obrigatório' : '',
        horaColeta: clienteDGKPSC ? 'Campo obrigatório' : '',
        sexo: clienteDGKPSC ? 'Campo obrigatório' : '',
        cpf: clienteDGKPSC ? 'Campo obrigatório' : ''
    };

    const initialFocus = {
        numeroEtiqueta: false,
        empresa: false,
        tipoAmostra: false,
        tipoConservacao: false,
        nomePaciente: false,
        cpf: false       
    };
    const [camposTiveramFoco, setCamposTiveramFoco] = useState(initialFocus);

    return {
        validationSchema,
        initialValues,
        initialErrors,
        camposTiveramFoco,
        setCamposTiveramFoco,
        initialFocus
    };
};

export default useForm;